import axios from 'axios'

export const updateNotificationSubscription = ({ type, endpoint, deviceName, keyP256dh, keyAuth }) => {
  return axios.post('/notification-device', {
    type,
    endpoint,
    deviceName,
    keyP256dh,
    keyAuth,
  })
}

export const getUnreadNotifications = () => {
  return axios.get('/notification/search', {
    params: {
      orderByColumn: 'id',
      orderByDirection: 'desc',
      status: ['TO BE SENT', 'SENT'],
    },
  })
}

export const getAllNotifications = ({ limit = 50 } = {}) => {
  return axios.get('/notification/search_notification', {
    params: {
      orderByColumn: 'id',
      orderByDirection: 'desc',
      limit: limit,
    },
  })
}

export const readAllMyNotifications = () => {
  return axios.get('/notification/read-all-my-notifications')
}

export const hasUnreadNotifications = () => {
  return axios.get('/notification/has-unread-notifications')
}

export const readNotification = ({ id }) => {
  return axios.put(`/notification/${id}/status/READ`)
}

export const markAsClickedNotification = ({ id }) => {
  return axios.put(`/notification/mark-clicked/${id}`)
}
